module.exports = __webpack_public_path__ + "img/new3-img4.a061ab41.jpg";